import { render, staticRenderFns } from "./BillOfLadingDetailDialog.vue?vue&type=template&id=20820839"
import script from "./BillOfLadingDetailDialog.vue?vue&type=script&lang=js"
export * from "./BillOfLadingDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports